import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Feedback from './pages/Feedback';
import FeedbackAdminPage from './pages/FeedbackAdminPage';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import EmployeeList from './pages/EmployeeList';
import UserManagementPage from './pages/UserManagementPage';
import RoleManagement from './pages/RoleManagement';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import EducationTrainingPage from './pages/EducationTrainingPage';
import TrainingRecordsPage from './pages/TrainingRecordsPage';
import TrainingLearningPage from './pages/TrainingLearningPage';
import ExamSystemPage from './pages/ExamSystemPage';
import EmployeeFilesPage from './pages/EmployeeFilesPage'; // 引入新页面
import EmployeeOverviewPage from './pages/EmployeeOverviewPage';
import Settings from './pages/Settings';
import WorkPlansPage from './pages/WorkPlansPage';
import AccessCardManagementPage from './pages/AccessCardManagementPage';
import EmployeeChangesPage from './pages/EmployeeChangesPage';
import EmployeeOnboardingFlowPage from './pages/EmployeeOnboardingFlowPage';
import HRNotificationsPage from './pages/HRNotificationsPage';
import SpecialMonitoringPage from './pages/SpecialMonitoringPage';
import DutyTasksPage from './pages/DutyTasksPage';
import BehaviorControlPage from './pages/BehaviorControlPage';
import BehaviorDailyCheckinPage from './pages/BehaviorDailyCheckinPage';
import ContributionsPage from './pages/ContributionsPage';
import EmployeeInsurancePage from './pages/EmployeeInsurancePage';
import TempWorkerUsagePage from './pages/TempWorkerUsagePage';
import WorkNotesPage from './pages/WorkNotesPage';
import FileManagerPage from './pages/FileManagerPage';
import HRDataPage from './pages/Daily/HRDataPage';
import SafetyPointsPage from './pages/Daily/SafetyPointsPage';
import DormManagementPage from './pages/Daily/DormManagementPage';
import ReimbursementPage from './pages/Daily/ReimbursementPage';

import EmployeeVehiclesPage from './pages/EmployeeVehiclesPage';
import TrainingEntrustPage from './pages/TrainingEntrustPage';
// 引入请假加班模块页面
import NewLeaveApplicationForm from './pages/LeaveOvertime/NewLeaveApplicationForm';
import OvertimeApplicationForm from './pages/LeaveOvertime/OvertimeApplicationForm';
import ApprovalPage from './pages/LeaveOvertime/ApprovalPage';
import LedgerList from './pages/LeaveOvertime/LedgerList';
import DataAnalysisView from './pages/LeaveOvertime/DataAnalysisView';
import LeaveOvertimePage from './pages/LeaveOvertime/LeaveOvertimePage';
// 引入隐患排查模块页面
import DormHazardPage from './pages/Hazard/DormHazardPage';
import RiskClassificationPage from './pages/Hazard/RiskClassificationPage';
import SafetyInspectionPage from './pages/Hazard/SafetyInspectionPage';
import RiskIdentificationPage from './pages/Hazard/RiskIdentificationPage';
import QuickShotPage from './pages/Hazard/QuickShotPage';
import MobileLayout from './components/MobileLayout';
import MobileHomePage from './pages/Mobile/MobileHomePage';
import MobileTrainingPage from './pages/Mobile/MobileTrainingPage';
import MobileHazardReportPage from './pages/Mobile/MobileHazardReportPage';
import MobileCheckinPage from './pages/Mobile/MobileCheckinPage';
import MobileMePage from './pages/Mobile/MobileMePage';
import MyProfilePage from './pages/Management/MyProfilePage';
import OnboardingMaterialsPage from './pages/Management/OnboardingMaterialsPage';
import ApiCenterPage from './pages/Management/ApiCenterPage';
import ApiPermissionPage from './pages/Management/ApiPermissionPage';
import './App.css';

import './theme.css';

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/register" element={<Register />} />
            
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              {/* Nested routes will render inside the Layout's <Outlet> */}
              <Route index element={
                <ProtectedRoute permissions={['dashboard_view','view_dashboard']}>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="dashboard" element={
                <ProtectedRoute permissions={['dashboard_view','view_dashboard']}>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route 
                path="employees" 
                element={
                  <ProtectedRoute permissions={['view_employees']}>
                    <EmployeeList />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="employees/training-entrust"
                element={
                  <ProtectedRoute permissions={['view_employees','manage_trainings','manage_education_training']}>
                    <TrainingEntrustPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="employee-changes"
                element={
                  <ProtectedRoute permissions={['employee_changes_view','employee_changes_admin','manage_hr_changes']}> 
                    <EmployeeChangesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="employee-onboarding"
                element={
                  <ProtectedRoute permissions={['employee_changes_view','manage_hr_changes']}>
                    <EmployeeOnboardingFlowPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="hr-notifications"
                element={
                  <ProtectedRoute permissions={['hr_notifications_view','hr_notifications_manage','hr_notifications_publish']}>
                    <HRNotificationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="education-training"
                element={
                  <ProtectedRoute permissions={['manage_trainings','manage_education_training']}>
                    <Navigate to="/education-training/dashboard" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="education-training/dashboard"
                element={
                  <ProtectedRoute permissions={['manage_trainings','manage_education_training']}>
                    <EducationTrainingPage mode="dashboard" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="education-training/ledger"
                element={
                  <ProtectedRoute permissions={['manage_trainings','manage_education_training']}>
                    <EducationTrainingPage mode="ledger" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="education-training/records"
                element={
                  <ProtectedRoute permissions={['view_my_training_records','view_education_training','manage_trainings','manage_education_training']}>
                    <TrainingRecordsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="education-training/records/learn/:planId"
                element={
                  <ProtectedRoute permissions={['view_my_training_records','view_education_training','manage_trainings','manage_education_training']}>
                    <TrainingLearningPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="exam-system"
                element={
                  <ProtectedRoute permissions={['exam_view','exam_attempt','exam_manage']}>
                    <ExamSystemPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="employee-files" 
                element={
                  <ProtectedRoute permissions={['view_employees', 'manage_archives']}>
                    <EmployeeFilesPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="archives" 
                element={
                  <ProtectedRoute permissions={['manage_archives']}>
                    <EmployeeOverviewPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="settings" 
                element={
                  <ProtectedRoute permissions={['manage_settings','manage_org_meta']}>
                    <Settings />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/daily/work-plans" 
                element={
                  <ProtectedRoute permissions={['work_plans_view','work_plans_view_all','work_plans_manage']}>
                    <WorkPlansPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="management/users" 
                element={
                  <ProtectedRoute permissions={['manage_users']}>
                    <UserManagementPage />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="management/feedback"
                element={
                  <ProtectedRoute permissions={['project_manager']}>
                    <FeedbackAdminPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="management/roles" 
                element={
                  <ProtectedRoute permissions={['manage_roles']}>
                    <RoleManagement />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="management/my-profile"
                element={
                  <ProtectedRoute permissions={['my_profile_view','my_profile_manage','manage_settings','manage_roles','manage_users']}>
                    <MyProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/onboarding-materials"
                element={
                  <ProtectedRoute permissions={['onboarding_materials_view','onboarding_materials_manage','manage_settings','manage_roles']}>
                    <OnboardingMaterialsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/api-center"
                element={
                  <ProtectedRoute permissions={['manage_api_test']}>
                    <ApiCenterPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/api-permissions"
                element={
                  <ProtectedRoute permissions={['manage_api_permissions']}>
                    <ApiPermissionPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="daily/access-cards" 
                element={
                  <ProtectedRoute permissions={['view_access_cards','manage_access_cards']}>
                    <AccessCardManagementPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/daily/special-monitoring" 
                element={
                  <ProtectedRoute permissions={['manage_education_training','special_monitoring_task_manage','special_monitoring_record_manage','special_monitoring_view_all']}>
                    <SpecialMonitoringPage />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/daily/duty-tasks"
                element={
                  <ProtectedRoute permissions={['duty_task_manage','duty_task_record_manage','duty_task_view_all']}>
                    <DutyTasksPage />
                  </ProtectedRoute>
                }
              />
              {/* 行为管控模块占位路由 */}
              <Route
                path="/daily/behavior"
                element={
                  <ProtectedRoute permissions={['behavior_tags_manage','behavior_tags_view','behavior_profile_view','behavior_dashboard_view','behavior_intervention_manage','behavior_intervention_view']}>
                    <BehaviorControlPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/behavior-tags"
                element={
                  <ProtectedRoute permissions={['behavior_tags_manage','behavior_tags_view']}>
                    <BehaviorControlPage defaultTab="tags" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/safety-profile"
                element={
                  <ProtectedRoute permissions={['behavior_profile_view']}>
                    <BehaviorControlPage defaultTab="profile" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/behavior-dashboard"
                element={
                  <ProtectedRoute permissions={['behavior_dashboard_view']}>
                    <BehaviorControlPage defaultTab="dashboard" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/behavior-intervention"
                element={
                  <ProtectedRoute permissions={['behavior_intervention_manage','behavior_intervention_view']}>
                    <BehaviorControlPage defaultTab="intervention" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/behavior-daily-checkin"
                element={
                  <ProtectedRoute permissions={['behavior_daily_checkin_view','behavior_daily_checkin_manage','behavior_dashboard_view']}>
                    <BehaviorDailyCheckinPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/daily/contributions" 
                element={
                  <ProtectedRoute permissions={['view_employees','contributions_view','contributions_manage']}>
                    <ContributionsPage />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/daily/employee-insurance"
                element={
                  <ProtectedRoute permissions={['view_employees','contributions_view','contributions_manage']}>
                    <EmployeeInsurancePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/temp-worker-usage"
                element={
                  <ProtectedRoute permissions={['view_employees']}>
                    <TempWorkerUsagePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/work-notes"
                element={
                  <ProtectedRoute permissions={['view_employees']}>
                    <WorkNotesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/file-manager"
                element={
                  <ProtectedRoute permissions={['manage_archives','view_employees']}>
                    <FileManagerPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/hr-data"
                element={
                  <ProtectedRoute permissions={['view_employees']}>
                    <HRDataPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/safety-points"
                element={
                  <ProtectedRoute permissions={['safety_points_view','safety_points_manage']}>
                    <SafetyPointsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/dorms"
                element={
                  <ProtectedRoute permissions={['dorm_view','dorm_manage']}>
                    <DormManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/reimbursements"
                element={
                  <ProtectedRoute permissions={['reimbursement_view','reimbursement_manage']}>
                    <ReimbursementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/employee-vehicles"
                element={
                  <ProtectedRoute permissions={['employee_vehicles_view','employee_vehicles_manage','vehicle_violations_view_all','vehicle_violations_manage']}>
                    <EmployeeVehiclesPage />
                  </ProtectedRoute>
                }
              />
              {/* 请假加班模块路由 */}
              <Route
                path="/daily/leave-overtime"
                element={
                  <ProtectedRoute permissions={['leave_application_view','leave_application_submit','leave_application_create','overtime_application_view','overtime_application_submit','overtime_application_create','leave_overtime_ledger_view']}>
                    <LeaveOvertimePage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/daily/leave-overtime/new-leave-application"
                element={
                  <ProtectedRoute permissions={['leave_application_view','leave_application_submit','leave_application_create']}>
                    <NewLeaveApplicationForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/leave-overtime/overtime-application"
                element={
                  <ProtectedRoute permissions={['overtime_application_view','overtime_application_submit','overtime_application_create']}>
                    <OvertimeApplicationForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/leave-overtime/approval"
                element={
                  <ProtectedRoute permissions={['leave_overtime_approval','leave_application_approve','overtime_application_approve']}>
                    <ApprovalPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/leave-overtime/ledger"
                element={
                  <ProtectedRoute permissions={['leave_overtime_ledger_view']}>
                    <LedgerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daily/leave-overtime/data-analysis"
                element={
                  <ProtectedRoute permissions={['leave_overtime_data_analysis']}>
                    <DataAnalysisView />
                  </ProtectedRoute>
                }
              />
              {/** 组织层级独立路由已移除，统一到设置页 Tab 中 */}
              {/* 隐患排查模块路由 */}
              <Route
                path="/hazard/dorm"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <DormHazardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/risk-classification"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <RiskClassificationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/risk-identification"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <RiskIdentificationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/risk-point"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <RiskIdentificationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/risk-points"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <RiskIdentificationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/safety-inspection"
                element={
                  <ProtectedRoute permissions={['hazard_view','hazard_manage']}>
                    <SafetyInspectionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hazard/quick-shot"
                element={
                  <ProtectedRoute permissions={['hazard_quick_shot_view','hazard_quick_shot_manage','hazard_view','hazard_manage']}>
                    <QuickShotPage />
                  </ProtectedRoute>
                }
              />
              {/* Add other protected routes here */}
            </Route>

            <Route
              path="/m"
              element={
                <ProtectedRoute>
                  <MobileLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<MobileHomePage />} />
              <Route path="training" element={<MobileTrainingPage />} />
              <Route path="hazards" element={<MobileHazardReportPage />} />
              <Route path="checkin" element={<MobileCheckinPage />} />
              <Route path="me" element={<MobileMePage />} />
              <Route
                path="me/training-records"
                element={
                  <ProtectedRoute permissions={['view_my_training_records','view_education_training','manage_trainings','manage_education_training']}>
                    <TrainingRecordsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="me/training-records/learn/:planId"
                element={
                  <ProtectedRoute permissions={['view_my_training_records','view_education_training','manage_trainings','manage_education_training']}>
                    <TrainingLearningPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* Fallback for any other path */}
            <Route path="*" element={<div><h2>404 Not Found</h2></div>} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;

